export interface PaginationResponse {
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
  sortBy: string;
  sortOrder: string;
}

export interface PaginationParam {
  page: number;
  pageSize: number;
}

export const mapPaginationResponse = (response: any): PaginationResponse => {
  if (!response) {
    return {
      page: 1,
      pageSize: 10,
      total: 0,
      totalPages: 0,
      sortBy: "",
      sortOrder: "asc",
    };
  }
  return {
    page: response.page || 1,
    pageSize: response.pageSize || 10,
    total: response.total || 0,
    totalPages: response.totalPages || 0,
    sortBy: response.sortBy || "",
    sortOrder: response.sortOrder || "asc",
  };
};
